// extracted by mini-css-extract-plugin
export default {"block":"styles-module__[local]___ByNyu","wide":"styles-module__[local]___HU-tP","narrow":"styles-module__[local]___0k7De","container":"styles-module__[local]___CsnE4"};